// extracted by mini-css-extract-plugin
export default {"workOrderWorkListModal":"styles_workOrderWorkListModal__UueyD","flexTitle":"styles_flexTitle__ZlFNg"};